import { Frequency } from "../interfaces/frequency";
import { Type } from "../interfaces/type";
import { Person } from "../interfaces/persons";
import { WBS } from "../interfaces/wbs";

export class WbsService {
  private baseUrl = "http://lschulz.one:3100";

  async getTypes(): Promise<Array<Type>> {
    const response = await fetch(`${this.baseUrl}/types`);
    const data = await response.json();

    return data.map((item: Type) => ({
      value: item.value,
      description: item.description,
    }));
  }

  async getFrequencies(): Promise<Array<Frequency>> {
    const response = await fetch(`${this.baseUrl}/frequencies`);
    const data = await response.json();

    return data.map((item: Frequency) => ({
      value: item.value,
      description: item.description,
    }));
  }

  calculateWbs(person: Array<Person>): Promise<WBS> {
    console.log(person)

    console.log(JSON.stringify(person))

    return fetch(`${this.baseUrl}/calculate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(person),
    })
      .then((response) => response.json())
      .then((data) => data as WBS);
  }
}